export const presetData = [
  {
    name: 'Preset Design 1: 15ft Chimney (6" Typical)',
    description: "6-inch diameter chimney: single-wall black pipe indoors, 90° elbow, horizontal triple-wall through wall, vertical triple-wall outdoors.",
    config: {
      parts: [
        {
          _name: "Black pipe (indoor vertical)",
          type: "single",
          inner_diameter_ft: 0.5,
          height_ft: 6.125,
          z_ft: 0,
          orientation: "vertical",
          T_ambient_K: 295.15,
          Pa: 98457,
          num_segments: 6,
          thickness_w_m: 0.00076,
          density_w_kg_m3: 7850,
          cp_w_J_kg_K: 460,
          k_w_W_m_K: 50,
          epsilon_w: 0.8,
          roughness_m: 0.00015
        },
        {
          _name: "Horizontal insulated pipe (through wall)",
          type: "triple",
          inner_diameter_ft: 0.5,
          height_ft: 1.9375,
          z_ft: 0,
          orientation: "horizontal",
          T_ambient_K: 275.15,
          Pa: 98596,
          num_segments: 2,
          thickness_inner_m: 0.0005,
          density_inner_kg_m3: 7850,
          cp_inner_J_kg_K: 460,
          k_inner_W_m_K: 26,
          epsilon_inner: 0.35,
          thickness_middle_m: 0.025,
          density_middle_kg_m3: 100,
          cp_middle_J_kg_K: 1050,
          k_middle_W_m_K: 0.04,
          thickness_outer_m: 0.0005,
          density_outer_kg_m3: 8000,
          cp_outer_J_kg_K: 500,
          k_outer_W_m_K: 16,
          epsilon_outer: 0.35,
          air_gap_inner_m: 0.0,
          air_gap_outer_m: 0.0,
          roughness_m: 1e-6
        },
        {
          _name: "Vertical insulated pipe (outdoors)",
          type: "triple",
          inner_diameter_ft: 0.5,
          height_ft: 5.917,
          z_ft: 0,
          orientation: "vertical",
          T_ambient_K: 275.15,
          Pa: 98596,
          num_segments: 8,
          thickness_inner_m: 0.0005,
          density_inner_kg_m3: 7850,
          cp_inner_J_kg_K: 460,
          k_inner_W_m_K: 26,
          epsilon_inner: 0.35,
          thickness_middle_m: 0.025,
          density_middle_kg_m3: 100,
          cp_middle_J_kg_K: 1050,
          k_middle_W_m_K: 0.04,
          thickness_outer_m: 0.0005,
          density_outer_kg_m3: 8000,
          cp_outer_J_kg_K: 500,
          k_outer_W_m_K: 16,
          epsilon_outer: 0.35,
          air_gap_inner_m: 0.0,
          air_gap_outer_m: 0.0,
          roughness_m: 1e-6
        }
      ],
      elbows: [
        {
          type: "tee",
          between_parts: [-1, 0],
          diameter_ft: 0.5,
          vertical_length_ft: 1.0,
          horizontal_length_ft: 0.5417,
          T_ambient_K: 295.15
        },
        {
          type: "elbow",
          between_parts: [0, 1],
          diameter_ft: 0.5,
          height_ft: 0.625,
          width_ft: 0.7083,
          angle_deg: 90,
          R_over_D: 1.5,
          elbow_type: "long_radius",
          T_ambient_K: 295.15
        },
        {
          type: "tee",
          between_parts: [1, 2],
          diameter_ft: 0.5,
          vertical_length_ft: 1.0,
          horizontal_length_ft: 0.5417,
          T_ambient_K: 275.15
        }
      ],
      dt: 0.5,
      total_time: 600,
      inlet_restriction: {
        enable: true,
        door_type: "swivel",
        door_width_ft: 1.2708,
        door_height_ft: 0.8229,
        Cd: 0.62,
        A_leak_m2: 0.0125,
        inlet_area_min_m2: 0.003,
        K_stove: 0.0
      },
      door_schedule: [[0, 100], [90, 100], [95, 50], [300, 50], [305, 0]],
      inlet_temp_profile: [
        [0, 473],
        [60, 523],
        [120, 548],
        [180, 523],
        [300, 473],
        [600, 423]
      ],
      verbose: false
    }
  }
];

export const elbowData = [
  { 
    name: "90 Degree Elbow", 
    type: "Elbow", 
    diameters: ["3", "4", "5", "6", "7", "8"], 
    material: "0.02\" 430 stainless steel", 
    surface: "smooth",
    description: "90° elbow fitting for directional changes. Made from 430 stainless steel with smooth interior surface."
  },
  { 
    name: "45 Degree Elbow", 
    type: "Elbow", 
    diameters: ["3", "4", "5", "6", "7", "8"], 
    material: "0.02\" 430 stainless steel", 
    surface: "smooth",
    description: "45° elbow fitting for gradual directional changes. Reduces draft resistance compared to 90° bends."
  },
  { 
    name: "Tee", 
    type: "Elbow", 
    diameters: ["3", "4", "5", "6", "7", "8"], 
    material: "0.02\" 430 stainless steel", 
    surface: "smooth",
    description: "T-junction fitting for connecting branch pipes. Features one inlet and two outlets for versatile installations."
  },
  { 
    name: "Cap", 
    type: "Elbow", 
    diameters: ["3", "4", "5", "6", "7", "8"], 
    material: "0.02\" 430 stainless steel", 
    surface: "smooth",
    description: "End cap for sealing pipe terminations. Provides weatherproof closure for chimneys."
  }
];

// Vent options shown to the user as a categorized dropdown.
// Mirrors the `vent_options` section of the backend pipe_props.json
// (at flued_dynamics/dev/exp_data/pipe_props.json). Per-layer material
// properties are duplicated here so the payload assembler in App.js can
// emit a ready-to-simulate config without an extra lookup step. The
// user enters diameter and length separately on the canvas.
export const ventOptions = [
  // ============================================================
  // STOVE PIPE — single-wall connectors and flex liners
  // ============================================================
  {
    id: 'stovepipe-carbon-steel',
    name: 'Single-wall Steel',
    category: 'stove_pipe',
    construction: 'single-wall',
    simulator_type: 'single',
    surface_finish: 'smooth',
    max_flue_temp_C: 760,
    description: 'Single-wall stove pipe connector, 24-gauge cold rolled (typically black-painted) carbon steel.',
    inner: { material: 'steel_24_gauge', density_kg_m3: 7850, k_W_m_K: 50, cp_J_kg_K: 460, emissivity: 0.23, roughness_m: 1.5e-4, thickness_m: 0.000607 },
  },
  {
    id: 'stovepipe-stainless',
    name: 'Single-wall Stainless',
    category: 'stove_pipe',
    construction: 'single-wall',
    simulator_type: 'single',
    surface_finish: 'smooth',
    max_flue_temp_C: 760,
    description: 'Single-wall stove pipe connector, 0.020" 430 stainless steel.',
    inner: { material: 'stainless_430', density_kg_m3: 7850, k_W_m_K: 26, cp_J_kg_K: 460, emissivity: 0.15, roughness_m: 1e-6, thickness_m: 0.000508 },
  },
  // NOTE: Flex liners (`flexible-liner-smooth` and `flexible-liner-corrugated`)
  // are intentionally hidden from this frontend list — they're relining products
  // typically used inside masonry chimneys. They remain in the backend
  // pipe_props.json catalog and will be surfaced when the "Lined Masonry Chimney"
  // UI category is added in a later release.
  {
    id: 'stovepipe-double-wall-laser-welded',
    name: 'Double-wall',
    category: 'stove_pipe',
    construction: 'double-wall',
    simulator_type: 'triple',
    surface_finish: 'smooth',
    max_flue_temp_C: 760,
    description: 'Laser-welded double-wall stove pipe connector: 0.016" 430 stainless inner / 7/16" air gap / 0.018" satin-coat steel outer.',
    inner:  { material: 'stainless_430',    density_kg_m3: 7850, k_W_m_K: 26,   cp_J_kg_K: 460,  emissivity: 0.15, roughness_m: 1e-6, thickness_m: 0.000406 },
    middle: { material: 'air',              density_kg_m3: 1.20, k_W_m_K: 0.026, cp_J_kg_K: 1005,                                      thickness_m: 0.01111 },
    outer:  { material: 'satin_coat_steel', density_kg_m3: 7850, k_W_m_K: 50,   cp_J_kg_K: 460,  emissivity: 0.25, roughness_m: 1e-5, thickness_m: 0.000457 },
  },

  // ============================================================
  // CHIMNEY — double-wall and triple-wall (Class A) products
  // ============================================================
  {
    id: 'chimney-double-wall-air-cooled',
    name: 'Air Cooled',
    category: 'chimney',
    construction: 'double-wall',
    simulator_type: 'triple',
    surface_finish: 'smooth',
    max_flue_temp_C: 760,
    description: 'Double-wall air-cooled chimney pipe (no insulation): 0.016" 430 stainless inner / ~1" air-cooling gap / 0.020" galvanized or galvalume outer.',
    inner:  { material: 'stainless_430',  density_kg_m3: 7850, k_W_m_K: 26,   cp_J_kg_K: 460,  emissivity: 0.15, roughness_m: 1e-6,    thickness_m: 0.000406 },
    middle: { material: 'air',            density_kg_m3: 1.20, k_W_m_K: 0.026, cp_J_kg_K: 1005,                                          thickness_m: 0.0254 },
    outer:  { material: 'steel_24_gauge', density_kg_m3: 7850, k_W_m_K: 50,   cp_J_kg_K: 460,  emissivity: 0.23, roughness_m: 1.5e-4, thickness_m: 0.000508 },
  },
  {
    id: 'chimney-class-a-stainless',
    name: 'Class A (Stainless)',
    category: 'chimney',
    construction: 'triple-wall',
    simulator_type: 'triple',
    surface_finish: 'smooth',
    max_flue_temp_C: 1149,
    description: 'Class A insulated chimney pipe: 0.020" 430 stainless inner / 1" thermal-tech ceramic-fiber blanket / 0.016" 430 stainless outer.',
    inner:  { material: 'stainless_430', density_kg_m3: 7850, k_W_m_K: 26,   cp_J_kg_K: 460,  emissivity: 0.15, roughness_m: 1e-6, thickness_m: 0.000508 },
    middle: { material: 'ceramic_fiber', density_kg_m3: 100,  k_W_m_K: 0.04, cp_J_kg_K: 1050, emissivity: 0.75,                    thickness_m: 0.0254 },
    outer:  { material: 'stainless_430', density_kg_m3: 7850, k_W_m_K: 26,   cp_J_kg_K: 460,  emissivity: 0.15, roughness_m: 1e-6, thickness_m: 0.000406 },
  },
  {
    id: 'chimney-triple-wall-air-cooled-insulated',
    name: 'Triple-wall',
    category: 'chimney',
    construction: 'triple-wall',
    simulator_type: 'triple',
    surface_finish: 'smooth',
    max_flue_temp_C: 1149,
    // Physical construction is 5 layers (inner SS / 1/2" insulation / galvalume middle wall / 1.5" air / galvanized outer).
    // Approximated here as 3 layers with a "combined middle" material whose
    // density, k, and cp are chosen to preserve both total R and total thermal capacity of the actual middle stack.
    description: 'Triple-wall air-cooled insulated Class A chimney pipe: 0.016" 430 stainless inner / 1/2" thermal-tech insulation + 1.5" air cooling gap (with intermediate 0.018" galvalume wall) / 0.018" galvanized outer.',
    inner:  { material: 'stainless_430',            density_kg_m3: 7850, k_W_m_K: 26,    cp_J_kg_K: 460, emissivity: 0.15, roughness_m: 1e-6,    thickness_m: 0.000406 },
    middle: { material: 'duraplus_middle_combined', density_kg_m3: 200,  k_W_m_K: 0.0288, cp_J_kg_K: 293, emissivity: 0.75,                       thickness_m: 0.0513 },
    outer:  { material: 'steel_24_gauge',           density_kg_m3: 7850, k_W_m_K: 50,    cp_J_kg_K: 460, emissivity: 0.23, roughness_m: 1.5e-4, thickness_m: 0.000457 },
  },

  // ============================================================
  // LINED MASONRY CHIMNEY — metal-liner (relined) brick chase
  // ============================================================
  // Modeled as 3 layers: a stainless-steel flue liner (optionally combined
  // with insulation) / air void / clay brick chase. This represents a masonry
  // chase relined with a metal liner — there is no clay-tile liner in these
  // options. The rectangular masonry flue is treated as a round-equivalent
  // (hydraulic) diameter via the diameter input. The brick exterior is the
  // heat-loss boundary, so masonry parts use the outdoor ambient temperature
  // (set in App.js payload assembly).
  //
  // The insulated variants lump the steel liner + insulation into one effective
  // inner layer: k preserves the series thermal resistance and rho*cp preserves
  // the combined areal heat capacity (cp fixed at the insulation value); liner
  // taken as 0.010" 316 stainless flex. Base props from flued_dynamics
  // pipe_props.json (stainless_316, vermiculite, mineral_wool). Thicknesses per
  // Eric's review (2026-05): vermiculite 1", mineral wool 1/2" wrap, ~1/2" air gap.
  // Uninsulated is split into flex vs rigid liner. Thermally they are nearly
  // identical (the thin steel's resistance + heat capacity are negligible next
  // to the air void + brick) — the split is for an honest, recognizable user
  // choice. Flex (0.010") is most of the market; rigid liners run 0.016-0.020".
  {
    id: 'lined-masonry-flex',
    name: 'Uninsulated (flex liner)',
    category: 'masonry',
    construction: 'masonry',
    simulator_type: 'triple',
    surface_finish: 'smooth',
    max_flue_temp_C: 1149,
    description: 'Relined masonry chimney, uninsulated flex liner (most common): 0.010" 316 stainless flex liner / ~3/4" air void / 4" clay brick chase.',
    inner:  { material: 'stainless_316', density_kg_m3: 8000, k_W_m_K: 16,    cp_J_kg_K: 500,  emissivity: 0.15, roughness_m: 1e-6, thickness_m: 0.000254 },
    middle: { material: 'air',           density_kg_m3: 1.20, k_W_m_K: 0.026, cp_J_kg_K: 1005,                   thickness_m: 0.019 },
    outer:  { material: 'brick_clay',    density_kg_m3: 1800, k_W_m_K: 0.72,  cp_J_kg_K: 840,  emissivity: 0.93, roughness_m: 3e-3, thickness_m: 0.102 },
  },
  {
    id: 'lined-masonry-rigid',
    name: 'Uninsulated (rigid liner)',
    category: 'masonry',
    construction: 'masonry',
    simulator_type: 'triple',
    surface_finish: 'smooth',
    max_flue_temp_C: 1149,
    description: 'Relined masonry chimney, uninsulated rigid liner: 0.020" 316 stainless rigid liner / ~3/4" air void / 4" clay brick chase.',
    inner:  { material: 'stainless_316', density_kg_m3: 8000, k_W_m_K: 16,    cp_J_kg_K: 500,  emissivity: 0.15, roughness_m: 1e-6, thickness_m: 0.000508 },
    middle: { material: 'air',           density_kg_m3: 1.20, k_W_m_K: 0.026, cp_J_kg_K: 1005,                   thickness_m: 0.019 },
    outer:  { material: 'brick_clay',    density_kg_m3: 1800, k_W_m_K: 0.72,  cp_J_kg_K: 840,  emissivity: 0.93, roughness_m: 3e-3, thickness_m: 0.102 },
  },
  {
    id: 'lined-masonry-vermiculite',
    name: 'Vermiculite insulation',
    category: 'masonry',
    construction: 'masonry',
    simulator_type: 'triple',
    surface_finish: 'smooth',
    max_flue_temp_C: 1149,
    description: 'Relined masonry chimney with vermiculite around the liner: combined 316 stainless flex liner + 1"-2" vermiculite inner / ~1/2" air gap / 4" brick chase.',
    inner:  { material: 'stainless_plus_vermiculite', density_kg_m3: 166, k_W_m_K: 0.0586, cp_J_kg_K: 840,  emissivity: 0.15, roughness_m: 1e-6, thickness_m: 0.0257 },
    middle: { material: 'air',                        density_kg_m3: 1.20, k_W_m_K: 0.026, cp_J_kg_K: 1005,                   thickness_m: 0.013 },
    outer:  { material: 'brick_clay',                 density_kg_m3: 1800, k_W_m_K: 0.72,  cp_J_kg_K: 840,  emissivity: 0.93, roughness_m: 3e-3, thickness_m: 0.102 },
  },
  {
    id: 'lined-masonry-mineral-wool',
    name: 'Mineral wool insulation',
    category: 'masonry',
    construction: 'masonry',
    simulator_type: 'triple',
    surface_finish: 'smooth',
    max_flue_temp_C: 1149,
    description: 'Relined masonry chimney with mineral wool around the liner (most common reline): combined 316 stainless flex liner + 1/2" mineral-wool inner / ~1/2" air gap / 4" brick chase.',
    inner:  { material: 'stainless_plus_mineral_wool', density_kg_m3: 191, k_W_m_K: 0.0306, cp_J_kg_K: 840,  emissivity: 0.15, roughness_m: 1e-6, thickness_m: 0.013 },
    middle: { material: 'air',                         density_kg_m3: 1.20, k_W_m_K: 0.026, cp_J_kg_K: 1005,                   thickness_m: 0.013 },
    outer:  { material: 'brick_clay',                  density_kg_m3: 1800, k_W_m_K: 0.72,  cp_J_kg_K: 840,  emissivity: 0.93, roughness_m: 3e-3, thickness_m: 0.102 },
  },
];

// Convenience accessor for components that need to look up an option by id.
export function findVentOption(id) {
  return ventOptions.find(v => v.id === id) || null;
}